import OtherProducts from "./OtherProducts";

export default OtherProducts;
